import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
// import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {Toaster} from 'react-hot-toast';
import {AuthProvider} from './context/AuthContext';

import AppRoutes from './routes/AppRoutes';
import AxiosIntercepters from './components/AxiosIntercepters';
import reactQueryClient from './services/reactQuery';

import './index.css';

const toastOptions = {
  className: 'text-white bg-[#333]',
  duration: 1600,
};

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          <AxiosIntercepters />
          <Toaster
            position="top-center"
            reverseOrder={false}
            toastOptions={toastOptions}
          />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
